import { TextField } from "@material-ui/core";

type ViewOnlyTextFieldProps = {
  label: string;
  value: string;
};

export const ViewOnlyTextField: React.FC<ViewOnlyTextFieldProps> = ({
  label,
  value,
}) => {
  return (
    <TextField
      label={label}
      value={value}
      margin="dense"
      fullWidth
      variant="filled"
      onChange={(e) => e.preventDefault()}
    />
  );
};
